import { useLang } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="footer">
      <div className="container row spread">
        <div>
          <strong style={{ color: 'var(--ink)' }}>🌊 Life in Nha Trang</strong>
          <div>{t('footer.tagline')}</div>
        </div>
        <div>© {new Date().getFullYear()} Life in Nha Trang</div>
      </div>
    </footer>
  );
}
